import { AfterViewInit, Component, effect, EffectRef, ElementRef, inject, Injector, signal, Signal, ViewChild, WritableSignal } from '@angular/core';
import { MenuItemComponent } from './menu-item/menu-item.component';
import { MenuService } from '../../../../../services/components/menu.service';
import { DvmService } from '../../../../../services/dvm.service';
import { AppViews } from '../../../../../models/enums/dvm/DvmViews.enum';
import { MenuContent } from '@models/interfaces/components/Menu.interface';
import anime from 'animejs';
import { LayoutService } from '@services/layout.service';
import { MapViewerService } from '@3ddv/ngx-dvm-internal';
import { ButtonColors } from '@models/enums/components/Button/ButtonColor.enum';
import { TranslationService } from '@services/translation.service';

@Component({
    selector: 'app-menu-container',
    imports: [
        MenuItemComponent
    ],
    standalone: true,
    templateUrl: './menu-container.component.html',
    styleUrl: './menu-container.component.css'
})
export class MenuContainerComponent implements AfterViewInit {

  // VIEW CHILDS
  @ViewChild('menuContainer') 
  public menuContainer!:          ElementRef<HTMLDivElement>;

  @ViewChild('menuItems', {read: ElementRef})
  public menuItems!:  	          ElementRef<HTMLDivElement>;
  
  // SERVICE
  private readonly menuService:   MenuService             = inject(MenuService);
  private readonly dvm:           DvmService              = inject(DvmService);
  public  readonly translation:   TranslationService      = inject(TranslationService);
  private readonly injector:      Injector                = inject(Injector);
  

  // GLOBAL STATE
  public readonly view:           Signal<AppViews|null>   = inject(DvmService).view;
  public readonly isMobile:       Signal<boolean>         = inject(LayoutService).isMobile;
  public readonly viewer:         MapViewerService        = this.dvm.viewer;

  // STATE
  public showContainer:           Signal<boolean | null>  = this.menuService.showContainer;
  public hideElement:             WritableSignal<boolean> = signal(true);

  // ANIMATION STATE
  public isAnimating:             WritableSignal<boolean> = this.menuService.isAnimating;
  public duration:                number                  = this.menuService.animation;

  // GETTERS
  public get isShortViewport(): boolean {
    return window.innerHeight < 500;
  }

  public get isVip(): boolean {
    return this.menuService.menuSelected?.buttonType === ButtonColors.Vip;
  }

  public get menuContents(): MenuContent[] {
    return this.menuService.menuSelected?.content || [];
  }


  // EFFECTS
  public onViewChange:            EffectRef               = effect((): void => {
      
      const view: AppViews | null = this.view();
  
      if(view === null) return;
  
      if (view === AppViews.Seatmap || view === AppViews.Pano) {
        
        if (this.menuService.menuSelected) this.menuService.closeMenuContainer();
        
      }
  
  });

  
  public showMenuContainerChange?: EffectRef;

  // LIFECYCLE HOOKS
  public ngAfterViewInit(): void {
    this.showMenuContainerChange = effect((): void => {
      const state = this.menuService.showContainer();

      if (state === null) return;

      this.toggleMenuContainer(state);
    }, {injector: this.injector});
  }
  
  public get Title(): string {

    return (this.menuService.menuSelected?.label || '') + ' Seating';

  }

  public get AvailableLabel(): string {

    const length: number = this.menuContents.length;

    return `${length} ${this.translation.getText('menu', 'available_options')}`;

  }
  
  // METHODS
  private toggleMenuContainer(show: boolean): void {
       
    // SI ES TRUE SE MUESTRA EL ELEMENTO
    if(show) this.hideElement.set(false);

    // ANIMATION
    anime({
      begin:    (): void => this.isAnimating.set(true),
      complete: (): void => { 
        if(!this.showContainer()) this.hideElement.set(true);
        this.isAnimating.set(false);
      }, 
      duration:   this.isMobile() ? this.duration + 100 : this.duration,
      targets:    this.menuContainer.nativeElement,
      translateY: show ? [100 , 0] : [0, 100],
      opacity:    show ? 1 : 0,
      easing:     'easeInOutQuad',
    })

  }

}
